<template>
  <SheetContainer title="段落静音" desc="每个段落结尾的静音时长设置，设置后全文默认值生效">
    <span class="toggle-btn" slot="title-right" @click="onToggleClick"><i class="size36"
        :class="[globeMuteVisible ? 'icon-show' : 'icon-hide']"></i>{{ globeMuteVisible ? "显示" : "隐藏" }}</span>
    <div class="content-header">
   
    <van-radio-group @change="changemuteType" v-model="muteType" direction="horizontal" class="extract-radio-group">
      <span v-for="(fun, idx) in functionList" :key="idx">
        <van-radio  icon-size="26px" :name="fun.name"  :disabled="fun.switchStatus&&!isEffectUpdate">
          {{ fun.functionName }}
        </van-radio>
      </span>
      <!-- <van-radio icon-size="26px" name="video"> 视频文件提取 </van-radio> -->
    </van-radio-group>
    </div>
   
    <ul class="sheet-list">
      <li v-for="(item, index) in muteObjs" :key="item.id" class="sheet-item"
        :class="{ checked: selectedValue === item.value,default:muteType=='isAll'?item.value=='200':item.value==globalMuteTime }" @click="onSelectClick(index)">
        <span>{{ item.name }}</span>
      </li>
      <li class="sheet-item custom" :class="{ customized }" @click="onCustomClick">
        <span>{{ customText }}</span>
      </li>
      <li
        class="sheet-item remove"
        :class="{ removable }"
        @click="onRemoveClick"
      >
        <span>恢复默认</span>
      </li>
    </ul>
    <InputModal title="自定义静音时长" type="number" placeholder="请输入5000ms以内静音" :visible.sync="customInputVisible"
      @confirm="onCustomInput" />
  </SheetContainer>
</template>
<script>
import { muteTimeList } from "@/views/index/config/muteList";
import InputModal from "@/components/input-modal/input-modal.vue";
import SheetContainer from "../sheet-container/sheet-container.vue";
import { toast } from "@/utils/util";
import { customCollectEvent } from '@/utils/collect';
export default {
  props: {
    value: {
      // 选中值信息
      type: String,
      default: "",
    },
    globalMuteTime: {
      // 选中值信息
      type: String,
      default: "200",
    },
    isEffectUpdate: {
      // 选中值信息
      type: Boolean,
      default: false,
    },
    globeMuteVisible:{
      type: Boolean,
      default: false,
    },
    isUpdate:{
      type: Boolean,
      default: false,
    },
  },
  components: {
    SheetContainer,
    InputModal,
  },
  data() {
    return {
      muteObjs: muteTimeList.map((item,index) => {
        return {
          ...item,
          id: index + 1,
          visible: false
        };
      }), // 预置的静音选项
      selectedValue: "", //当前选中的值，未选中或者清除时值为""
      customInputVisible: false, // 自定义弹窗是否显示
     
      functionList: [{ // 功能id
        name: 'isAll',
        functionName: '所有段落',
        switchStatus: false// true展示，false隐藏
      },
      {
        name: 'isSelf',
        functionName: '当前段落',
        switchStatus: true
      }],
      muteType:'isSelf'
    };
  },
  computed: {
    removable() {
      return this.muteType=="isAll"?this.globalMuteTime!="200":this.muteType=="isSelf"?this.selectedValue!=this.globalMuteTime:false;
    },
    customized() {
      return (
        this.selectedValue &&
        !this.muteObjs.some((mute) => mute.value === this.selectedValue)
      );
    },
    customText() {
      return this.customized ? this.selectedValue : "+自定义";
    },
  },
  watch: {
    value: {
      immediate: true,
      handler() {
          this.selectedValue = this.value;
      }
    },
    isEffectUpdate: {
      immediate: true,
      handler() {
        if(this.isEffectUpdate){
          this.muteType="isSelf"
          this.selectedValue = this.value;
        }else{
          this.muteType="isAll"
          this.selectedValue = this.globalMuteTime
        }
        
      },
    },
  },
  methods: {
    //插入/修改静音
    onSelectClick(index) {
      const seletedMute = this.muteObjs[index];
      this.updateValue(seletedMute.value);
    },
    changemuteType(){
      if(this.muteType=="isAll"){
        this.selectedValue=this.globalMuteTime
      }else{
        this.selectedValue=this.value
        
      }
    },
    // 显隐段落静音
    onToggleClick() {
      const visible = !this.globeMuteVisible;
      this.$emit("visible-change",visible);
      if (visible) {
        customCollectEvent("editor_tools_click",{
          type: "查看拼音",
        });
      }
    },
    // 恢复默认
    onRemoveClick() {
      if(this.muteType=="isAll"){
        this.$emit("change",'200',this.muteType);
        this.selectedValue = '200';
      }else{
        this.$emit("change",this.globalMuteTime,this.muteType,true);
        this.selectedValue = this.globalMuteTime;
      }
      // this.updateValue("");
    },
    // 打开自定义弹窗
    onCustomClick() {
      this.customInputVisible = true;
    },
    // 自定义输入
    onCustomInput(value) {
      if (!/^[1-9][0-9]*$/.test(value)) {
        toast("静音时长必须是正整数");
        return;
      }
      if (value > 5000) {
        toast("静音时长不能超过5000ms");
        return;
      }
      this.updateValue(value);
    },
    // 更新静音值
    updateValue(newValue) {
      if (newValue !== this.selectedValue) {
        this.selectedValue = newValue;
        this.$emit("change",newValue,this.muteType);
        if (newValue) {
          customCollectEvent("editor_duanluojingyin",{
            time: +newValue,
          });
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
i.size36 {
  display: inline-block;
  width: 0.36rem;
  height: 0.36rem;
  background-size: cover;
  vertical-align: -0.08rem;
  margin-right: 2px;
}

.icon-show {
  background-image: url("~@/assets/images/icon_show@2x.png");
}

.icon-hide {
  background-image: url("~@/assets/images/icon_hide@2x.png");
}

.content .toggle-btn {
  font-size: 0.26rem;
  font-weight: 400;
  color: #999999;
}

.content-header {
    font-size: 30px;
    line-height: 38px;
    color: #333;
    padding: 0rem 0 0.1rem 0;
    height:39px;
    display: flex;
    // justify-content: center;
    margin: 0px 0px 56px 0px;
    box-sizing: border-box;

    .img-icon {
      height: 20px;
    }

    .van-radio-group--horizontal {
    
      justify-content: flex-start;
      width: 100%;
    }
    .van-radio--horizontal:first-child{
      margin-right: 56px;
    }
    
  }
  .default{
      position: relative;
      &::after{
        right: 0;
        top: 0;
        content: "默认";
        position: absolute;
        width: 50px;
        text-align: center;
        height: 26px;
        background: #FFFFFF;
        border-radius: 0px 10px 0px 10px;
        border: 1px solid #cedcef;
        font-size: 20px;
        font-family: 'HarmonyOS_Sans_SC';
        font-weight: 500;
        color: #999;
        line-height: 24px;
      }
    }
    .checked.default{
      &::after{
        color: #4A90E2;
        border: 1px solid #3583FB;
      }
    }
</style>